var _defs, _g, _g2, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g3, _path10, _path11, _path12, _ellipse, _path13, _ellipse2, _path14, _line, _ellipse3, _path15, _path16, _g4, _path17, _path18, _path19, _rect, _rect2, _path20, _path21, _circle, _circle2, _rect3, _rect4, _g5, _polygon, _polygon2, _polygon3, _polygon4, _polygon5, _g6, _rect5, _g7, _g8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNano3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 765.7 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\n        stroke-linecap: round;\n      }\n\n      .cls-1, .cls-2, .cls-4 {\n        stroke: #1e333a;\n        stroke-linejoin: round;\n      }\n\n      .cls-1, .cls-6 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #1e333a;\n      }\n\n      .cls-2, .cls-4 {\n        opacity: .4;\n      }\n\n      .cls-7 {\n        fill: #010101;\n        isolation: isolate;\n        opacity: .6;\n      }\n\n      .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-6, .cls-19, .cls-20 {\n        stroke-width: 0px;\n      }\n\n      .cls-8 {\n        fill: #e0e0df;\n        opacity: .7;\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        fill: none;\n      }\n\n      .cls-3, .cls-5 {\n        stroke: #192338;\n        stroke-miterlimit: 10;\n      }\n\n      .cls-10, .cls-11 {\n        fill-rule: evenodd;\n      }\n\n      .cls-10, .cls-18 {\n        fill: #d60010;\n      }\n\n      .cls-11, .cls-17 {\n        fill: #c4c5c7;\n      }\n\n      .cls-12 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-15 {\n        fill: #263238;\n      }\n\n      .cls-16 {\n        fill: #192338;\n      }\n\n      .cls-19 {\n        fill: #ec1c25;\n      }\n\n      .cls-20 {\n        fill: #ff4d4f;\n      }\n\n      .cls-5 {\n        stroke-width: .8px;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 149,
    y1: 401.2,
    x2: 338.9,
    y2: 401.2,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eff0f7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#c9cbe6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 180.4,
    y1: 454.5,
    x2: 330.4,
    y2: 454.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 146.9,
    y1: 296.3,
    x2: 169.4,
    y2: 296.3,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-18",
    x: 210.2,
    y: 117.1,
    width: 194.9,
    height: 13.1
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 217.8,
    cy: 123.6,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 225.4,
    cy: 123.6,
    r: 2.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 233,
    cy: 123.6,
    r: 2.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 210.2,
    y: 130.2,
    width: 194.9,
    height: 133.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 215.6,
    y: 149.4,
    width: 107.2,
    height: 60.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 215.6,
    y: 210,
    width: 107.2,
    height: 6.2
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 269.2,
    cy: 179.7,
    r: 13.3
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "265.5 179.7 265.5 174.1 270.3 176.9 275.2 179.7 270.3 182.5 265.5 185.2 265.5 179.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 215.6,
    y: 208.7,
    width: 107.2,
    height: 1.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 215.6,
    y: 208.7,
    width: 46.8,
    height: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-20",
    cx: 262.5,
    cy: 209.4,
    r: 1.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 332.1,
    y: 149.4,
    width: 21.8,
    height: 21.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 360.2,
    y: 149.4,
    width: 31.8,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 360.2,
    y: 158.2,
    width: 31.8,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 360.2,
    y: 166.8,
    width: 15.9,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 331.1,
    y: 187.2,
    width: 21.8,
    height: 21.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 359.2,
    y: 187.2,
    width: 31.8,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 359.2,
    y: 196,
    width: 31.8,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 359.2,
    y: 204.7,
    width: 15.9,
    height: 4.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 331.1,
    y: 220.3,
    width: 21.8,
    height: 21.8
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 359.2,
    y: 220.3,
    width: 31.8,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 359.2,
    y: 229.1,
    width: 31.8,
    height: 4.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 359.2,
    y: 237.7,
    width: 15.9,
    height: 4.3
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "455.1 55 547 55 547 192.6 439.8 192.6 439.8 70.3 455.1 55"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "519.9 55 519.9 70.3 535.2 70.3 519.9 55"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "449 49.4 540.9 49.4 540.9 186.9 433.7 186.9 433.7 64.6 449 49.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 448.3,
    y: 74.3,
    width: 22.8,
    height: 13.1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 477.5,
    y: 74.3,
    width: 49.6,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 477.5,
    y: 83.2,
    width: 49.6,
    height: 4.2
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 448.3,
    y: 97.6,
    width: 78.8,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 448.3,
    y: 106.5,
    width: 78.8,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 448.3,
    y: 115.3,
    width: 78.8,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 448.3,
    y: 124.2,
    width: 78.8,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 448.3,
    y: 133.1,
    width: 78.8,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 448.3,
    y: 142,
    width: 78.8,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 448.3,
    y: 150.8,
    width: 78.8,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 448.3,
    y: 159.7,
    width: 78.8,
    height: 4.2
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 448.3,
    y: 168.6,
    width: 78.8,
    height: 4.2
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "449 49.4 449 64.6 433.7 64.6 449 49.4"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m539.3,305.4c-30.8-65.2-91.7-63.9-91.7-63.9h-33.1s-54.2-1.3-84.9,63.9c-30.8,65.2-32.3,152.4-32.3,152.4h232.6c23.2,0,41.1-20.3,38.3-43.3-3.9-31-11.9-73.4-28.8-109.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m372.4,404.2s.2,12.3,8.8,16.3,14.4-1.8,14.4-1.8v21.5l.7,8.3,1.8,2.8,1.7,3.3-16.7-.4-8.2-3.9-5.5-17.3,3.1-28.7Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "m459.5,254.4c0-4.4-1.1-8.6-3-12.3-5.5-.7-8.9-.7-8.9-.7h-33.1s-1.9,0-5.1.3c-2,3.8-3.2,8.1-3.2,12.6,0,14.7,11.9,26.7,26.7,26.7s26.7-11.9,26.7-26.7Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m368.4,321.1s-5,70.2,16.2,136.7h-16.2s-17.3-71.9,0-136.7Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m447.8,209.6s-1.6,4.8.9,9.1c0,0-4.3,2.7-7.6-2.3-3.2-5,3.2-9.7,6.6-6.8Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "m386.9,170.2s-8.6,14.4,6,24.6c12.2,8.6,12.4-20.4,12.4-20.4,0,0-7.7-6.9-10.3-6.7-2.6.3-8.1,2.5-8.1,2.5Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m442.6,212.1c-6,10.4-18,20.4-28.4,20.5h0v22.1c0,10.1,8.2,18.2,18.2,18.2h0c11.5,0,20.1-10.5,17.9-21.7l-7.7-39Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m414.2,235.7h0v12.4c27.6-8.4,28.4-36.1,28.4-36.1-6.7,13.7-18,23.6-28.4,23.6Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m392,168.7s-6,35.7,6.3,56.5c12.1,20.6,33.9,8.3,44.4-13.1,0,0,8.8-.8,10.6-9.7,1.8-8.9-3.5-12.1-8.7-9.9v-23.8h-52.5Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m338.9,457.8h-156.4l-33.2-106.7c-1-3.3,1.4-6.6,4.8-6.6h145.8c2.2,0,4.2,1.4,4.8,3.6l34.2,109.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m149.2,349.5h145.8c2.2,0,4.2,1.4,4.8,3.6l32.6,104.8h6.4l-34.2-109.7c-.7-2.1-2.6-3.6-4.8-3.6h-145.8c-2.8,0-4.9,2.3-5,4.9,0,0,0,0,.2,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 324.8,
    y: 451.2,
    width: 81.6,
    height: 6.6
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 180.4,
    y: 451.2,
    width: 150,
    height: 6.6
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m395,191.2s5.7-2.7,9.7.7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m411,194.8s1.3,5.7-4.1,11.3-.3,5.1,4.8,5.4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m405.7,221.3s13.1,3.9,17.5-7.5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 400.2,
    cy: 198.9,
    rx: 3.5,
    ry: 4.8
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m427,191.2s-5.7-2.7-9.7.7"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-16",
    cx: 421.8,
    cy: 198.9,
    rx: 3.5,
    ry: 4.8
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "m444.5,192.5s-9.5-1.5-12.3-13.2c0,0-9.8,5.9-27.5,4-21.4-2.3-26.9-26-13.4-39.1,0,0,1.3,10.2,14,6.6,19.9-5.6,28.2-3.3,31.2,2,0,0,11.1-2.4,15.1,9.5,4,11.8-2.2,29.7-2.2,29.7,0,0-2.8-.5-4.9.5Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 127.4,
    y1: 457.8,
    x2: 636.9,
    y2: 457.8
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-7",
    cx: 235.6,
    cy: 404.2,
    rx: 7.5,
    ry: 8.9,
    transform: "translate(-89.7 68) rotate(-13.8)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m398.1,451.2s-9.2-34.4,20.4-40.6c29.5-6.2,84.6,5.3,84.6,5.3,0,0-16.2-50.3-21.7-93,0,0-5.5,38.6,8.7,81.1,0,0-56.2-10.6-80.8,1.4-24.6,12-15.8,40.6-11.2,45.7Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m411.5,426.1s-21.8,1.6-36.6-1.1c0,0-15.3-4-18-8.9-2.8-4.9-8.6,4.4.8,12.4-10.2,6.6-14.5,22.7-9.5,22.7,0,0,2.4.4,5.2-3.1-.7,3.1,1,5.8,6.8,3.1,1.5-.7,2.9-1.8,4-2.9-.9,2.4,1.1,5.6,6.8,2.9,1.5-.7,2.8-1.7,3.9-2.8-.9,2.4,1.3,5.8,6.9,2.8,4.8-2.6,6.6-5.8,6.6-5.8l25.3-.4c1.8-12.7-2.2-19-2.2-19Z"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m370.8,449.3c-4.3,3-5.8,2.4-5.8,2.4,1.1.8,3.1,1,6-.4,1.5-.7,2.8-1.7,3.9-2.8,0,0,6.7-8.6,5.5-8.3-1.3.3-5.3,6.1-9.6,9.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m353.4,448.1s8.1-8.7,6.8-8.6-4.8,3.7-8.9,7.9c-3.3,3.4-4.3,3.1-4.6,2.9.3.5.8.9,1.5.9,0,0,2.4.4,5.2-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m369.1,439.8c-1.6.4-5.9,7.1-9.7,10.1-3.8,2.9-5.6,1.3-5.7,1.3.8,1.3,2.8,1.7,6.4,0,1.5-.7,2.9-1.8,4-2.9,0,0,6.5-8.9,4.9-8.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m381.8,451.2c4.8-2.6,6.6-5.8,6.6-5.8l25.3-.4c.4-2.5.5-4.8.5-6.8-4.8,1.1-18.6,4.1-20.9,2.7-2.8-1.8-3.6-4.9-4.5-1.7-.8,3.1-4.9,7.9-8.2,10.6-3.3,2.7-5,1.8-5,1.8,1,1.1,3.1,1.4,6.3-.3Z"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m411.8,451.2c8-20.6-5.5-32.1-5.5-32.1"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m368.1,425.8c-1.8-.8-5.6.4-9.6-1.6-4-1.9-6-5.5-6-5.6-.1,2.7,1.1,6.4,5.2,9.8,4.1-2,12.3-1.8,10.5-2.7Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m568.4,419.1c-.1,0-36.8-3.5-32.7,38.3,18.8-2.8,32.9-19.2,32.7-38.3Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 382.3,
    y: 308.6,
    width: 88,
    height: 11
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 382.3,
    y: 327.6,
    width: 88,
    height: 11
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m511,278c-28.4,12.2-27.6,38.8-27.6,38.8,0,0,5.5-16.7,20.4-27.6s10.2-12.5,7.2-11.2Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m368.4,304s-6.5-19.2-10.8-26.4,11.1,2.7,10.8,26.4Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 311.3,
    cy: 454.2,
    r: 1.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-16",
    cx: 315.4,
    cy: 454.2,
    r: 1.2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 342,
    y: 453.4,
    width: 11.5,
    height: 1.5,
    rx: 0.8,
    ry: 0.8
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 131,
    y: 276.8,
    width: 160.9,
    height: 40.9,
    rx: 7.3,
    ry: 7.3
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "m169.4,296.3c0,2-.6,4.1-1.6,5.9-2,3.3-5.5,5.3-9.6,5.3s-7.6-2-9.6-5.3-1.6-3.7-1.6-5.9c0-6.1,5.1-11.2,11.2-11.2s11.2,5.1,11.2,11.2Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-19",
    cx: 158.4,
    cy: 291.4,
    r: 4.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "m167.8,302.3c-2,3.3-5.5,5.3-9.6,5.3s-7.6-2-9.6-5.3c2-3.3,5.5-5.3,9.6-5.3,4.1,0,7.8,2,9.6,5.3Z"
  }))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "187.5 287.4 190.4 293.3 196.9 294.2 192.2 298.8 193.3 305.3 187.5 302.3 181.7 305.3 182.8 298.8 178.1 294.2 184.6 293.3 187.5 287.4"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "209.6 287.4 212.5 293.3 219 294.2 214.3 298.8 215.4 305.3 209.6 302.3 203.8 305.3 204.9 298.8 200.2 294.2 206.7 293.3 209.6 287.4"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "231.1 287.4 234 293.3 240.5 294.2 235.8 298.8 236.9 305.3 231.1 302.3 225.2 305.3 226.4 298.8 221.6 294.2 228.2 293.3 231.1 287.4"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "252.8 287.4 255.8 293.3 262.3 294.2 257.6 298.8 258.7 305.3 252.8 302.3 247 305.3 248.1 298.8 243.4 294.2 249.9 293.3 252.8 287.4"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-17",
    points: "275 287.4 278 293.3 284.5 294.2 279.8 298.8 280.9 305.3 275 302.3 269.2 305.3 270.3 298.8 265.6 294.2 272.1 293.3 275 287.4"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 462.4,
    y: 202.3,
    width: 146,
    height: 34.1,
    rx: 6.4,
    ry: 6.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m496.6,226.1v-12.6h2.8v10.7h2.9v1.9h-5.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m503.4,215.6v-1.8h2.6v1.8h-2.6Zm0,10.5v-9h2.5v9h-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m508.7,226.1l-1.8-9h2.4l.7,5.8.7-5.8h2.4l-1.9,9h-2.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m517.1,226.3c-.7,0-1.2-.1-1.7-.4s-.8-.6-1.1-1c-.2-.5-.4-1-.4-1.6v-3.3c0-.6.1-1.2.4-1.6.2-.4.6-.8,1.1-1,.5-.2,1-.4,1.7-.4s1.2.1,1.7.3c.4.2.8.6,1,1,.2.4.3,1,.3,1.7v1.8h-3.6v1.7c0,.2,0,.4,0,.6,0,.1.1.2.2.3s.2,0,.3,0,.2,0,.3,0,.2-.1.2-.3c0-.1,0-.3,0-.5v-1h2.3v.9c0,.9-.3,1.6-.8,2.1-.5.5-1.3.7-2.2.7Zm-.6-5.7h1.3v-.9c0-.2,0-.4,0-.6,0-.1-.1-.2-.2-.3,0,0-.2,0-.4,0s-.2,0-.3,0c0,0-.2.2-.2.3,0,.2,0,.4,0,.6v.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m521.3,226.1l3.9-12.6h1.4l-3.9,12.6h-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m531.1,226.3c-.8,0-1.5-.1-2-.4s-.9-.7-1.2-1.3c-.3-.6-.4-1.3-.5-2.3l2.4-.4c0,.5,0,1,.1,1.3,0,.3.2.6.4.7s.4.2.6.2.5,0,.6-.3c0-.2.1-.4.1-.6,0-.5-.1-1-.4-1.3-.2-.4-.6-.7-1-1.1l-1.1-1c-.5-.4-.9-.9-1.2-1.4-.3-.5-.5-1.2-.5-1.9s.3-1.9,1-2.5c.6-.6,1.5-.9,2.6-.9s1.2.1,1.6.3c.4.2.7.5.9.9.2.4.4.8.4,1.2,0,.4.1.8.1,1.2l-2.4.3c0-.4,0-.7,0-1s-.1-.5-.2-.6c-.1-.2-.3-.2-.5-.2s-.5.1-.6.3c-.1.2-.2.4-.2.7,0,.5.1.9.3,1.1.2.3.5.6.9.9l1,.9c.6.5,1,1,1.4,1.6.4.6.6,1.3.6,2.2s-.1,1.1-.4,1.6c-.3.5-.7.9-1.1,1.1-.5.3-1.1.4-1.8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m538.6,226.3c-.7,0-1.2-.1-1.7-.4s-.8-.6-1.1-1c-.2-.5-.4-1-.4-1.6v-3.3c0-.6.1-1.2.4-1.6.2-.4.6-.8,1.1-1,.5-.2,1-.4,1.7-.4s1.2.1,1.7.3c.4.2.8.6,1,1,.2.4.3,1,.3,1.7v1.8h-3.6v1.7c0,.2,0,.4,0,.6,0,.1.1.2.2.3s.2,0,.3,0,.2,0,.3,0,.2-.1.2-.3c0-.1,0-.3,0-.5v-1h2.3v.9c0,.9-.3,1.6-.8,2.1-.5.5-1.3.7-2.2.7Zm-.6-5.7h1.3v-.9c0-.2,0-.4,0-.6,0-.1-.1-.2-.2-.3,0,0-.2,0-.4,0s-.2,0-.3,0c0,0-.2.2-.2.3,0,.2,0,.4,0,.6v.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m543.1,226.1v-12.6h2.5v12.6h-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m547.6,226.1v-7.3h-.9v-1.7h.9v-.7c0-.5,0-1,.2-1.4.1-.4.3-.7.7-.9s.9-.3,1.6-.3.4,0,.6,0c.2,0,.4,0,.6,0v1.9c0,0-.2,0-.3,0s-.2,0-.3,0c-.2,0-.3,0-.4.2-.1.1-.2.3-.2.5v.7h1.1v1.7h-1.1v7.3h-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m555.9,222.3v-1.6h4.1v1.6h-4.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m565.4,226.1v-12.6h4.2c.8,0,1.4.1,1.9.4.5.3.9.7,1.1,1.2s.4,1.2.4,2-.2,1.7-.5,2.2-.8.9-1.3,1.1c-.6.2-1.2.3-1.9.3h-1.1v5.4h-2.8Zm2.8-7.3h.9c.3,0,.6,0,.8-.2.2-.1.3-.3.4-.6,0-.2,0-.6,0-1s0-.6,0-.9c0-.2-.2-.4-.3-.6s-.5-.2-.8-.2h-.9v3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m575.2,226.3c-.5,0-.8-.1-1.2-.3-.3-.2-.5-.5-.7-.8s-.2-.7-.2-1c0-.6.1-1,.3-1.4s.5-.7.9-1c.4-.3.8-.5,1.2-.7.4-.2.9-.3,1.3-.5v-.9c0-.2,0-.3,0-.4s0-.2-.2-.3c0,0-.2-.1-.3-.1s-.3,0-.3,0c0,0-.1.1-.2.3,0,.1,0,.2,0,.4v.7c0,0-2.4,0-2.4,0,0-1.1.3-1.9.9-2.4.5-.5,1.3-.8,2.4-.8s1.6.3,2,.8c.5.5.7,1.2.7,2v4.2c0,.4,0,.7,0,1s0,.5,0,.7c0,.2,0,.4,0,.5h-2.3c0-.2,0-.5-.1-.8,0-.3,0-.4,0-.5-.1.4-.3.7-.6,1s-.7.4-1.1.4Zm.9-1.7c.1,0,.2,0,.3,0,0,0,.2,0,.2-.2,0,0,.1-.1.2-.2v-2.5c-.2.1-.4.3-.6.4-.2.1-.3.3-.5.4-.1.2-.2.3-.3.5,0,.2-.1.4-.1.6s0,.5.2.7c.1.2.3.3.5.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m583.7,226.3c-.7,0-1.2-.1-1.7-.4-.5-.2-.8-.6-1.1-1-.2-.4-.4-1-.4-1.6v-3.3c0-.6.1-1.2.4-1.6.2-.4.6-.8,1.1-1,.5-.2,1-.4,1.7-.4s1.2,0,1.6.3c.5.2.8.5,1,.9s.4.9.4,1.5v1h-2.4v-1c0-.2,0-.4,0-.6,0-.1-.1-.2-.2-.3,0,0-.2,0-.3,0s-.2,0-.3.1c0,0-.1.2-.2.3,0,.2,0,.4,0,.6v3.7c0,.4,0,.7.1.8,0,.1.2.2.4.2s.2,0,.3,0,.1-.2.2-.3c0-.1,0-.3,0-.5v-1.2h2.4v1.1c0,.6-.1,1.1-.4,1.5-.2.4-.6.7-1,.9-.5.2-1,.3-1.6.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m591,226.3c-.7,0-1.2-.1-1.7-.4s-.8-.6-1.1-1c-.2-.5-.4-1-.4-1.6v-3.3c0-.6.1-1.2.4-1.6.2-.4.6-.8,1.1-1,.5-.2,1-.4,1.7-.4s1.2.1,1.7.3c.4.2.8.6,1,1,.2.4.3,1,.3,1.7v1.8h-3.6v1.7c0,.2,0,.4,0,.6,0,.1.1.2.2.3s.2,0,.3,0,.2,0,.3,0,.2-.1.2-.3c0-.1,0-.3,0-.5v-1h2.3v.9c0,.9-.3,1.6-.8,2.1-.5.5-1.3.7-2.2.7Zm-.6-5.7h1.3v-.9c0-.2,0-.4,0-.6,0-.1-.1-.2-.2-.3,0,0-.2,0-.4,0s-.2,0-.3,0c0,0-.2.2-.2.3,0,.2,0,.4,0,.6v.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "m597.3,226.3c-.7,0-1.2-.2-1.5-.7-.4-.5-.5-1.2-.5-2.1v-3.7c0-.6,0-1.1.2-1.5.2-.4.4-.8.7-1,.3-.2.7-.4,1.2-.4s.6,0,1,.2c.3.1.6.3.8.5v-4.2h2.5v12.6h-2.5v-.7c-.3.3-.6.5-.9.6s-.6.2-.9.2Zm1.1-1.6c0,0,.2,0,.3,0,.1,0,.2,0,.4-.2v-5.7c-.1,0-.2,0-.3-.1-.1,0-.2,0-.3,0-.2,0-.4,0-.5.3-.1.2-.2.4-.2.7v4.1c0,.2,0,.4,0,.5,0,.2.1.3.2.4,0,0,.2.1.4.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-18",
    cx: 480.8,
    cy: 219.5,
    r: 9.9,
    transform: "translate(-16.7 41.2) rotate(-4.8)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "486.5 219.7 477.9 214.7 477.9 224.7 486.5 219.7"
  })))), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 221.5,
    y: 199.3,
    width: 95.5,
    height: 3.7
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "263.6 256.7 263.6 234.3 223.9 234.3 223.9 256.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 243.7,
    cy: 245.5,
    r: 4.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "242.3 245.5 242.3 243.5 244.1 244.5 245.9 245.5 244.1 246.6 242.3 247.6 242.3 245.5"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-11",
    points: "316.8 256.7 316.8 234.3 277.1 234.3 277.1 256.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-6",
    cx: 297,
    cy: 245.5,
    r: 4.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "295.6 245.5 295.6 243.5 297.4 244.5 299.2 245.5 297.4 246.6 295.6 247.6 295.6 245.5"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNano3);
export default __webpack_public_path__ + "static/media/nano3.f59b44bc67f400428d71cf4005cccda0.svg";
export { ForwardRef as ReactComponent };